

































import Vue from 'vue'
import SearchForm from '@/components/sub-components/SearchForm.vue'

export default Vue.extend({
  components: {
    SearchForm,
  },
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    selectedFilter: {
      type: Object,
      default: () => ({}),
    },
    searchText: {
      type: String,
      required: true,
    },
  },
})
